import React, { Component } from 'react';
import { connect } from 'react-redux';
import { routes } from 'constants/config';
import * as topicSelectors from 'selectors/learn/topics';
import { ContentGroup } from 'ui';
import TopicBadge from './TopicBadge';
import LearnContentCard from '../../shared/LearnContentCard';

class Topic extends Component {
  componentDidMount() {
    if (!this.props.topic) {
      window.location.href = routes.NOT_FOUND;
    }
  }

  render() {
    const { contents, topic } = this.props;
    return (
      <div>
        <TopicBadge />
        <ContentGroup
          className="LearnContentGroup mt-8"
          title={topic.name}
          description={topic.description}
          items={contents}
        >
          <ContentGroup.Items
            render={content => (
              <LearnContentCard
                key={`${content.id}.${content.type}`}
                {...content}
              />
            )}
          />
        </ContentGroup>
      </div>
    );
  }
}

const mapStateToProps = (state, { match }) => {
  // Topic is a Route component - the only way to tell which topic we are
  // looking at is the URL itself (e.g. /learn/topics/:id)
  // Using this id we can query the state for additional information
  const topicId = parseInt(match.params.id, 10);
  return {
    contents: topicSelectors.getContents(state, topicId),
    topic: topicSelectors.getTopic(state, topicId),
  };
};

export default connect(mapStateToProps)(Topic);
